import React from 'react';

import { PROP_TYPES } from '../../../../constants';

const ContentTypeString = ({column, content}) => (
  <div className="ContentTypeString">{content[column.name]}</div>
);  

export default ContentTypeString;

ContentTypeString.propTypes = {
  column: PROP_TYPES.COLUMN,
  content: PROP_TYPES.ROW
};
